import Vue from 'vue';
import VuePlyr from '@hulkapps/vue-plyr';
import '@hulkapps/vue-plyr/dist/vue-plyr.css';

Vue.use(VuePlyr, {
	plyr: {},
});
